import {FormArray, ValidatorFn} from '@angular/forms';

/**
 * Валидатор для проверки уникальности полей сортировки
 * @param form - форма
 */
export const uniqueFieldValidator: ValidatorFn = (form: FormArray) => {

    const fieldsIdList: string[] = form.value.map((item, index) => {
        const control = form.controls[index].get('field');

        if (control.errors !== null) {
            const newError: {[key: string]: any} = {};
            Object.keys(control.errors).forEach((key) => {
                if (key !== 'unique') {
                    newError[key] = control.errors[key];
                }
            });
            form.controls[index].get('field').setErrors(Object.keys(newError).length ? newError : null );
        }

        return item.field;
    });

    const filtered = fieldsIdList.filter((item, index) => fieldsIdList.indexOf(item) !== index);

    filtered.forEach((item) => {
        fieldsIdList.forEach((id, index) => {
            if (item === id) {
                const control = form.controls[index].get('field');
                const newError: {[key: string]: any} = control.errors ? control.errors : {};
                newError.unique = true;
                form.controls[index].get('field').setErrors(newError);
            }
        });
    });
    return null;
};



